(function () {
  const MOBILE_MAX = 989;
  const isMobile = () => window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;

  const SEL_WRAP = ".inkd-cardPricePopoverWrap";
  const SEL_BTN = ".inkd-pricingDetails";
  const SEL_INNER = ".inkd-pricingPopoverInner";

  let pop = null;
  let popContent = null;
  let activeWrap = null;
  let activeBtn = null;

  let closeTimer = null;

  function ensurePopover() {
    if (pop) return pop;

    pop = document.createElement("div");
    pop.className = "inkd-pricingPortal";
    pop.setAttribute("role", "dialog");
    pop.setAttribute("aria-label", "Pricing details");
    pop.setAttribute("aria-hidden", "true");

    pop.innerHTML = `
      <div class="inkd-pricingPortal__panel" role="document">
        <div class="inkd-pricingPortal__content"></div>
      </div>
    `;

    document.body.appendChild(pop);
    popContent = pop.querySelector(".inkd-pricingPortal__content");

    pop.addEventListener("mouseenter", cancelClose, true);
    pop.addEventListener("mouseleave", scheduleClose, true);

    return pop;
  }

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(() => closePopover(), 120);
  }

  function setAriaExpanded(btn, expanded) {
    if (!btn) return;
    btn.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  function closePopover() {
    if (!pop) return;

    pop.classList.remove("is-open");
    pop.setAttribute("aria-hidden", "true");
    if (popContent) popContent.innerHTML = "";

    setAriaExpanded(activeBtn, false);
    activeWrap = null;
    activeBtn = null;
  }

function positionPopover(btn) {
  if (!pop) return;

  const panel = pop.querySelector(".inkd-pricingPortal__panel");
  if (!panel) return;

  const r = btn.getBoundingClientRect();
  const margin = 8;
  const gutter = 10;

  panel.style.position = "fixed";
  panel.style.maxWidth = "min(420px, calc(100vw - 20px))";

  panel.style.left = "-9999px";
  panel.style.top = "-9999px";

  const panelRect = panel.getBoundingClientRect();
  const vw = document.documentElement.clientWidth;
  const vh = document.documentElement.clientHeight;

  const spaceBelow = vh - r.bottom - gutter;
  const spaceAbove = r.top - gutter;

  let placeBelow = spaceBelow >= panelRect.height || spaceBelow >= spaceAbove;

  let top = placeBelow
    ? (r.bottom + margin)
    : (r.top - margin - panelRect.height);

  top = Math.max(gutter, Math.min(top, vh - panelRect.height - gutter));

  let left = (r.left + (r.width / 2)) - (panelRect.width / 2);

  left = Math.max(
    gutter,
    Math.min(left, vw - panelRect.width - gutter)
  );

  panel.style.left = `${left}px`;
  panel.style.top = `${top}px`;

}




  function openFromWrap(wrap) {
    const btn = wrap.querySelector(SEL_BTN);
    const inner = wrap.querySelector(SEL_INNER);
    if (!btn || !inner) return;

    ensurePopover();

    if (activeWrap !== wrap) {
      popContent.innerHTML = inner.innerHTML;
      activeWrap = wrap;
      activeBtn = btn;
      setAriaExpanded(activeBtn, true);
    }

    pop.classList.add("is-open");
    pop.setAttribute("aria-hidden", "false");

    positionPopover(btn);
    requestAnimationFrame(() => positionPopover(btn));
  }

  document.addEventListener(
    "mouseover",
    function (e) {
      if (isMobile()) return;
      const wrap = e.target.closest(SEL_WRAP);
      if (!wrap) return;

      cancelClose();
      openFromWrap(wrap);
    },
    true
  );

  document.addEventListener(
    "mouseout",
    function (e) {
      if (isMobile()) return;
      const wrap = e.target.closest(SEL_WRAP);
      if (!wrap) return;

      if (wrap.contains(e.relatedTarget)) return;

      scheduleClose();
    },
    true
  );


  document.addEventListener(
    "focusin",
    function (e) {
      if (isMobile()) return;
      const wrap = e.target.closest(SEL_WRAP);
      if (!wrap) return;

      cancelClose();
      openFromWrap(wrap);
    },
    true
  );

  document.addEventListener(
    "focusout",
    function (e) {
      if (isMobile()) return;
      if (pop && pop.contains(e.relatedTarget)) return;

      const wrap = e.target.closest(SEL_WRAP);
      if (!wrap) return;

      scheduleClose();
    },
    true
  );

  document.addEventListener("keydown", function (e) {
    if (!pop || !pop.classList.contains("is-open")) return;
    if (e.key === "Escape") closePopover();
  });

  window.addEventListener(
    "scroll",
    function () {
      if (isMobile()) return;
      if (!pop || !pop.classList.contains("is-open") || !activeBtn) return;
      positionPopover(activeBtn);
    },
    true
  );

  window.addEventListener("resize", function () {
    if (!pop || !pop.classList.contains("is-open")) return;
    if (isMobile()) closePopover(); 
    else if (activeBtn) positionPopover(activeBtn);
  });
})();